export default __webpack_public_path__ + "static/specks-ebd6440ae2178b08f4b3ab7e982b0645.png";